import React from "react";
import { Typography, Box } from "@mui/material";
import MzCheckbox from "@markaaz/ui/MzCheckbox";
import MzAutocomplete from "@markaaz/ui/MzAutocomplete";
const sx = {
  autocomplete: {
    width: "400px"
  },
  checkbox: (theme) => ({
    "& .MuiTypography-root": {
      ...theme.typography.body1,
      paddingLeft: "10px"
    },
    "& .MuiCheckbox-root": {
      color: theme.palette.darkBlue.c50
    },
    "& .Mui-checked": {
      color: theme.palette.blue.c100
    },
    paddingLeft: "20px",
    "&.Mui-disabled": {
      "& .MuiCheckbox-root": {
        color: theme.palette.darkBlue.c20
      },
      "& .MuiFormControlLabel-label": {
        color: theme.palette.darkBlue.c50
      }
    }
  })
};

function PortfolioConfiguration({
  checkBoxValues,
  portfolios,
  selectedPortfolio,
  onPortfolioChange,
  onCheckBoxChange
}) {
  const showPortfolio = checkBoxValues.addNonMatches || checkBoxValues.addMatches;
  return (
    <Box>
      <Box p={5}>
        <Typography variant="body1M" color="blue.c100">
          Portfolio Selection
        </Typography>
        <Typography variant="body2" mt={1} mb={4}>
          Select if you would like to add the entity matches to a portfolio. A portfolio must be selected in order to
          enable monitoring.
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <MzCheckbox
            name="addMatches"
            checked={checkBoxValues.addMatches}
            onChange={onCheckBoxChange}
            sx={sx.checkbox}
            label={
              <span>
                Add <strong>Matches</strong> to Portfolio
              </span>
            }
          ></MzCheckbox>
          <MzCheckbox
            name="addNonMatches"
            checked={!checkBoxValues.showNonMatches ? false : checkBoxValues.addNonMatches}
            onChange={onCheckBoxChange}
            sx={sx.checkbox}
            disabled={!checkBoxValues.showNonMatches}
            label={
              <span>
                Add <strong>Non-Matches</strong> to Portfolio &nbsp;
                <span style={{ color: "#D14343" }}>
                  (Available if Show <strong>Non-Matches</strong> is selected above)
                </span>
              </span>
            }
          ></MzCheckbox>

          {showPortfolio && (
            <PortfolioCheckbox
              portfolios={portfolios}
              onPortfolioChange={onPortfolioChange}
              selectedPortfolio={selectedPortfolio}
              checkBoxValues={checkBoxValues}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

function PortfolioCheckbox({ portfolios, checkBoxValues, onPortfolioChange, selectedPortfolio }) {
  return (
    <Box sx={{ paddingLeft: "60px" }}>
      <Box mt={2}>
        <MzAutocomplete
          label="Select portfolio to be added"
          placeholder="Select"
          onChange={onPortfolioChange}
          options={portfolios}
          value={selectedPortfolio}
          required
          sx={sx.autocomplete}
        />
      </Box>
    </Box>
  );
}

export default PortfolioConfiguration;
